<template>
  <div :class="$style.topbar">
    <a-row type="flex" justify="center" align="top" :gutter="16">
      <a-col :span="2">
        <img :class="$style.logo" :src="logo" alt />
      </a-col>
      <a-col :span="17">
        <cui-menu-left :settings="settings" />
      </a-col>
      <a-col :span="5">
        <div class="home-container">
          <cui-home-menu v-if="userDetail" />
          <div>
            <a-tag color="#71283e" class="app-version" @click="redirectTo">
              V {{ version }}
            </a-tag>
          </div>
          <cui-profile-menu @displayLoader="showLoader" />
        </div>
      </a-col>
    </a-row>
  </div>
</template>

<script>
import CuiHomeMenu from '@/components/LayoutComponents/Topbar/HomeMenu'
import CuiProfileMenu from '@/components/LayoutComponents/Topbar/ProfileMenu'
import CuiMenuLeft from '@/components/LayoutComponents/MenuVertical'

export default {
  data: function() {
    return {
      userDetail: null,
      logo:
        process.env.BASE_URL + 'resources/images/KBKG-logo-only-web-noback.png',
      version: undefined,
    }
  },
  components: {
    CuiHomeMenu,
    CuiProfileMenu,
    CuiMenuLeft,
  },
  props: ['userDetails', 'settings'],
  mounted() {
    const user = JSON.parse(localStorage.getItem('userDetails'))
    const settings = JSON.parse(localStorage.getItem('userSettings'))
    this.version = settings.application.buildVersion
    if (user) {
      this.userDetail = user
    }
  },
  methods: {
    showLoader(flag) {
      this.$emit('showLoader', flag)
    },

    redirectTo() {
      if (this.$router.currentRoute.path !== '/releaseNotes') {
        this.$router.push('/releaseNotes')
      }
    },
  },
}
</script>

<style lang="scss" module>
@import "./style.module.scss";
</style>
